export const mainNavItems = [
  {
    id: "community",
    label: "Community",
    path: "/community",
    icon: "community",
  },

  {
    id: "pilgrim",
    label: "Pilgrim Membership",
    path: "/pilgrim-membership",
    icon: "globe",
  },

  {
    id: "faithstream",
    label: "Faith Stream",
    path: "/faith-stream",
    icon: "stream",
    premiumLock: true,
  },

  {
    id: "mentorship",
    label: "Mentorship",
    path: "/mentorship",
    icon: "profile",
    // premiumOnly: true,
    premiumLock: true,

  },
  {
    id: "profile",
    label: "Profile",
    path: "/profile",
    icon: "profile",
  },

  {
    id: "message",
    label: "Message",
    path: "/messages",
    icon: "about",
    premiumLock: true,

  },
];